import { render, staticRenderFns } from "./BitacoraTemplateForm.vue?vue&type=template&id=821dfd18&scoped=true&"
import script from "./BitacoraTemplateForm.vue?vue&type=script&lang=js&"
export * from "./BitacoraTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./BitacoraTemplateForm.vue?vue&type=style&index=0&id=821dfd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821dfd18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VProgressCircular,VSelect,VSnackbar,VSwitch,VTextField})
